import { Component, Input } from '@angular/core';
import { Review, AgentRating } from '../../../../classes/agentRating';
import { CommunicationService } from '../../../../services/communication.service';
import { SCREEN_SIZE } from '../../../../classes/enums';

@Component({
  selector: 'app-agent-reviews',
  templateUrl: './agent-reviews.component.html',
  styleUrls: ['./agent-reviews.component.scss']
})
export class AgentReviewsComponent {
  SCREEN_SIZE = SCREEN_SIZE;

  rating: AgentRating;
  reviews: Review[];
  currentPage: number = 0;
  totalPages: number = 0;
  readonly pageSize: number = 3;

  @Input() set setRating(r: AgentRating) {
    this.rating = r;
    this.reviews = r.reviews;
    this.reviews.forEach(review => {
      review.content = review.content
        .replace(/<\/?p>/g, '')           // remove <p> tags
        .replace(/<\s*br\s*\/>/g, '\n');  // replace <br/> with newlines
    });
    this.totalPages = Math.ceil(this.reviews.length / this.pageSize);
  }

  constructor(
    public communicationService: CommunicationService,
  ) { }

}
